import React, { useEffect, useRef, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon, XIcon, ZoomInIcon } from "lucide-react";
import { pdfPreviews } from "../data/pdfPreviews";
export function SampleCarousel() {
  const [index, setIndex] = useState(0);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const active = pdfPreviews[index];
  const total = pdfPreviews.length;
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    const handleClose = () => triggerRef.current?.focus();
    dialog.addEventListener("close", handleClose);
    return () => dialog.removeEventListener("close", handleClose);
  }, []);
  const openDialog = () => dialogRef.current?.showModal();
  const closeDialog = () => dialogRef.current?.close();
  const go = (delta: number) => setIndex(i => (i + delta + total) % total);
  return <section className="section wash" id="preview" aria-labelledby="preview-heading" data-id="element-107" data-mp="14ndcn0yyjv7l">
      <div className="shell" data-id="element-108" data-mp="1j1dc1q0qo6ha">
        <div className="section-intro" data-id="element-109" data-mp="1j36ib47fwoor">
          <p className="eyebrow" data-id="element-110" data-mp="1j02a7vqut8st">LOOK INSIDE</p>
          <h2 id="preview-heading" data-id="element-111" data-mp="1nzwzxvyw7sca">
            Look inside your <span data-id="element-112" data-mp="1a171od0c7mmc">ready-planned workshops</span>
          </h2>
          <p data-id="element-113" data-mp="1a0ni6rv1gq67">
            Five real pages from the Volume 1 workshop manual: a timed agenda, facilitator plan,
            printable role cards, model conversation and observation sheet.
          </p>
        </div>
        <div className="sample-layout" data-id="element-114" data-mp="10a2jz5ja1nnt">
          <div data-id="element-115" data-mp="152m0aa9cmwwb">
            <div className="sample-options" role="group" aria-label="Choose a sample page" data-id="element-116" data-mp="152dpqp0p83oa">
              {pdfPreviews.map((page, i) => <button key={page.id} type="button" aria-pressed={i === index} onClick={() => setIndex(i)} data-id="element-117" data-mp="qb4pllz66zww" data-mpi={i}>
                  <span data-id="element-118" data-mp="hdb4762y1qoi">PAGE {page.page}</span>
                  {page.label}
                  <ChevronRightIcon size={16} aria-hidden="true" data-id="element-119" data-mp="mab4t1h0y188" />
                </button>)}
            </div>
            <div className="sample-explanation" aria-live="polite" data-id="element-120" data-mp="2o2uzmsgqcyc8">
              <h3 data-id="element-121" data-mp="2j99zouvktuae">{active.heading}</h3>
              <p data-id="element-122" data-mp="2j88nuo6ql3rm">{active.text}</p>
            </div>
            <p className="small-note" data-id="element-123" data-mp="2ec0btjnu5qoo">
              These are actual pages from the main workshop PDF. Click any page to enlarge it
              and see the planning and materials included.
            </p>
          </div>
          <figure className="sample-figure" data-id="element-124" data-mp="36z4dpfrmtow8">
            <button ref={triggerRef} type="button" onClick={openDialog} aria-haspopup="dialog" aria-label={`Enlarge actual PDF page: ${active.label}`} data-id="element-125" data-mp="320t3h3xfdcdh">
              <img className="real-pdf-page" src={active.src} alt={active.alt} width={1125} height={2000} loading="lazy" decoding="async" data-id="element-126" data-mp="2sz39bqc5rzc0" />
              <span className="zoom-label" aria-hidden="true" data-id="element-127" data-mp="1mhg6zobzb7os">
                <ZoomInIcon size={15} data-id="element-128" data-mp="1hjwoudc5uark" /> Enlarge page
              </span>
            </button>
            <div className="sample-nav" data-id="element-129" data-mp="3t9cp216gxdvw">
              <button type="button" onClick={() => go(-1)} aria-label="Previous sample page" data-id="element-130" data-mp="3t68f0n6bnnxb">
                <ChevronLeftIcon size={18} aria-hidden="true" data-id="element-131" data-mp="1zdzxles8ix8" />
              </button>
              <span data-id="element-132" data-mp="6227lprrfjsm">
                {index + 1} / {total}
              </span>
              <button type="button" onClick={() => go(1)} aria-label="Next sample page" data-id="element-133" data-mp="avn052al3lkf">
                <ChevronRightIcon size={18} aria-hidden="true" data-id="element-134" data-mp="fsdenl6qq93q" />
              </button>
            </div>
            <figcaption data-id="element-135" data-mp="kqye3ie64or4">Volume 1 PDF · Page {active.page} · {active.label}</figcaption>
          </figure>
        </div>
      </div>

      <dialog ref={dialogRef} className="sample-dialog" aria-labelledby="sample-dialog-title" onClick={e => {
      if (e.target === dialogRef.current) closeDialog();
    }} data-id="element-136" data-mp="pp8afwbmpveb">
        <button type="button" className="dialog-close" onClick={closeDialog} aria-label="Close preview" data-id="element-137" data-mp="2vk1a1c63vtkf">
          <XIcon size={20} aria-hidden="true" data-id="element-138" data-mp="209lai7xeqynx" />
        </button>
        <h2 id="sample-dialog-title" className="sr-only" data-id="element-139" data-mp="20c7fbzswz02g">
          Volume 1 workshop preview: {active.label}
        </h2>
        <div className="dialog-body" data-id="element-140" data-mp="2a8aklej2betm">
          <img className="real-pdf-page real-pdf-page--large" src={active.src} alt={active.alt} width={1125} height={2000} decoding="async" data-id="element-141" data-mp="2a792iq3mps2e" />
        </div>
        <button type="button" className="dialog-done" onClick={closeDialog} data-id="element-142" data-mp="1hjmsayzwbp6k">
          Done
        </button>
      </dialog>
    </section>;
}